"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/**
 * @description 基于 React Hooks 封装的 model，适用于局部状态
 */
var react_1 = require("react");
var createModel_1 = tslib_1.__importStar(require("./createModel"));
/**
 * Model工厂
 * @param model
 * @param model.namespace 命令空间
 * @param model.state 初始状态
 * @param model.reducers 推导reducers和同步actions
 * @param model.effects 副作用，推导异步actions
 */
function Model(model) {
    return createModel_1.default(model);
}
exports.Model = Model;
function MM(model) {
    // cheat
    return createModel_1.default(tslib_1.__assign(tslib_1.__assign({}, model), { m: 1 /* HookModern */ }));
}
exports.MM = MM;
exports.M = Model;
var localOpts = { local: true };
// 层级嵌套的类型推断不好使
function bindDispatchToAction(actions, dispatch, model) {
    var modelEffects = model.effects;
    var put = process.env.NODE_ENV === 'test'
        ? function (action) {
            return require('react-dom/test-utils').act(function () {
                dispatch(action);
            });
        }
        : dispatch;
    var wrappedPut = createModel_1.putWrapper(put);
    var effects = { tPut: wrappedPut, tCall: createModel_1.tCall, namespace: model['namespace'] };
    return Object.keys(actions).reduce(function (newActions, actionName) {
        var originAction = actions[actionName];
        var originEffect = modelEffects[actionName];
        var opts = Array.isArray(originEffect)
            ? tslib_1.__assign(tslib_1.__assign({}, originEffect[1]), localOpts) : localOpts;
        var effect = originEffect
            ? createModel_1.effectWrapper(Array.isArray(originEffect) ? originEffect[0] : originEffect, effects, model.TYPES[actionName], opts)
            : undefined;
        newActions[actionName] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var action = originAction.apply(void 0, args);
            dispatch(action);
            return effect && effect(action);
            // @IMP: 移除副作用执行器
            // exeGenerator(effect, action);
        };
        return newActions;
    }, {});
}
exports.bindDispatchToAction = bindDispatchToAction;
var commonReducer = process.env.NODE_ENV === 'development'
    ? function (reducer) {
        return react_1.useMemo(function () { return function (prevState, action) {
            var newState = reducer(prevState, action);
            if (window.__TKIT_USE_MODEL_LOGGER__) {
                window.__TKIT_USE_MODEL_LOGGER__('LOCAL ACTION', action['type'], prevState, action, newState);
            }
            return newState;
        }; }, [reducer]);
    }
    : function (reducer) { return reducer; };
exports.useModel = function (model, initialState) {
    if (initialState === void 0) { initialState = model['state']; }
    var _a = react_1.useReducer(commonReducer(model.reducers), initialState), store = _a[0], dispatch = _a[1];
    var isNotUnmounted = react_1.useRef(true);
    // @IMP: 解除 dispatch 响应，避免内存泄露
    react_1.useEffect(function () {
        return function () {
            isNotUnmounted.current = false;
        };
    }, []);
    return [
        store,
        react_1.useMemo(function () {
            return bindDispatchToAction(model.actions, 
            // eslint-disable-next-line prefer-spread
            function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return isNotUnmounted.current && dispatch.apply(null, args);
            }, model);
        }, [model, dispatch])
    ];
};
tslib_1.__exportStar(require("./createModel"), exports);
exports.default = exports.useModel;
//# sourceMappingURL=useModel.js.map